import { render, staticRenderFns } from "./NewsListV2.vue?vue&type=template&id=d56bbf64"
import script from "./NewsListV2.vue?vue&type=script&lang=js"
export * from "./NewsListV2.vue?vue&type=script&lang=js"
import style0 from "./NewsListV2.vue?vue&type=style&index=0&id=d56bbf64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports